module.exports = __webpack_public_path__ + "static/img/setting.e93fdf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/setting.png
// module id = 3Bxs
// module chunks = 24